import { render } from "./ModalBootstrap.vue?vue&type=template&id=f718f6de"
import script from "./ModalBootstrap.vue?vue&type=script&lang=js"
export * from "./ModalBootstrap.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__